import { screenShare, vb } from "../../../libs/roomnew";
import { applyPerformanceSetting } from "./actions";
import { FRAMERATE_DROP_THRESHOLD_PERCENT, FRAMERATE_RECOVERY_CHECKS, FRAMERATE_RECOVERY_THRESHOLD_PERCENT, PERFORMANCE_FRAME_RATE, STOP_RECOVER_THRESHOLD, VB_FRAMERATE_DROP_THRESHOLD_PERCENT, VBG_PERFORMANCE_FRAME_RATE } from "./constants";
import { getPerformanceState, getSenderFrameRate } from "./functions";

export class LoadMonitor {
    constructor() {
        this.thresholds = FRAMERATE_DROP_THRESHOLD_PERCENT;
        this.maxFramerate = PERFORMANCE_FRAME_RATE.high;
        this.checksToAverage = 5;
        this.checkCount = 0;
        this.framerateSum = 0;
        this.lastFramerate = null;

        this.succcessiveRecoveryChecks = 0;
        this.recoversCount=0;
        this.allowRecover=true;
    }

    changeOptimizer(framerate) {
        if(framerate === undefined || screenShare.isSharing()){
            console.log("Framerate is undefined or screen sharing is active, skipping check");
            this.checkCount = 0;
            this.framerateSum = 0;
            this.succcessiveRecoveryChecks = 0;
            return;
        }
        if (this.checkCount < this.checksToAverage) {
            this.framerateSum += framerate ?? 0;
            this.checkCount++;
        } else {
            const {setting: currentSetting} = getPerformanceState();
            if(vb.effectPlaying){
                this.maxFramerate=currentSetting == 3 ? VBG_PERFORMANCE_FRAME_RATE.high : currentSetting == 2 ? VBG_PERFORMANCE_FRAME_RATE.balanced : VBG_PERFORMANCE_FRAME_RATE.low;
            }else{
                this.maxFramerate=currentSetting == 3 ? PERFORMANCE_FRAME_RATE.high : currentSetting == 2 ? PERFORMANCE_FRAME_RATE.balanced : PERFORMANCE_FRAME_RATE.low;
            }
            const averageFramerate = this.framerateSum / this.checksToAverage;

            const currentSettingName = currentSetting == 3 ? "high" : currentSetting == 2 ? "balanced" : "low";
            console.log("Max Framerate: ", this.maxFramerate);
            console.log("Average framerate: ", averageFramerate);
            const dropPercentage = ((this.maxFramerate - averageFramerate ) / this.maxFramerate) * 100;
            console.log("Framerate change: ", dropPercentage.toFixed(1)+ "%");
            const dropThreshold = vb.effectPlaying ? VB_FRAMERATE_DROP_THRESHOLD_PERCENT[currentSettingName] : FRAMERATE_DROP_THRESHOLD_PERCENT[currentSettingName];
            if (dropPercentage > dropThreshold) {
                //drop situation
                if(this.isOptimizerChangable() && currentSetting > 1){
                    console.log("Framerate drop detected, changing optimizer to ", currentSetting-1);
                    applyPerformanceSetting(currentSetting - 1, false, false);
                }else{
                    console.log(`Skiping framerate drop, is optimizer changable: ${this.isOptimizerChangable()}, current setting: ${currentSetting}`);
                }
                //reset recovery checks since we need to have successive checks in a row
                this.succcessiveRecoveryChecks = 0;
                if(this.recoversCount >= STOP_RECOVER_THRESHOLD){
                    this.allowRecover=false;
                }
            }else if(dropPercentage < FRAMERATE_RECOVERY_THRESHOLD_PERCENT){
                //recover situation
                this.succcessiveRecoveryChecks++;
                console.log("Framerate recovered checks: ", this.succcessiveRecoveryChecks)
                if(this.succcessiveRecoveryChecks >= FRAMERATE_RECOVERY_CHECKS){
                    if(this.isOptimizerChangable() && currentSetting < 3 && this.allowRecover){
                        console.log("Framerate recovered, changing optimizer to ", currentSetting+1);
                        applyPerformanceSetting(currentSetting + 1, false, false);
                        this.recoversCount++;
                    }else{
                        console.log(`Skiping framerate recover, is optimizer changable: ${this.isOptimizerChangable()}, current setting: ${currentSetting}, allow recover: ${this.allowRecover}`);
                    }
                    this.succcessiveRecoveryChecks = 0;
                }

            }else if(dropPercentage >= FRAMERATE_RECOVERY_THRESHOLD_PERCENT){
                //reset recovery checks since we need to have successive checks in a row
                this.succcessiveRecoveryChecks = 0;
            }


            this.lastFramerate = averageFramerate;
            this.checkCount = 0;
            this.framerateSum = 0;
        }
    }

    isOptimizerChangable(){
        const {setting, lastChangedByUser} = getPerformanceState();
        return setting > 2 || !lastChangedByUser;
    }

    startMonitor() {
        // Monitor the framerate and change the optimizer based on the framerate drop
        setInterval(async () => {
            const framerate = await getSenderFrameRate();
            this.changeOptimizer(framerate);
        }, 4000);
    }
}
